<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer mode="side" [opened]="!shouldHideNavigation" class="sidenav-fixed" *ngIf="!shouldHideNavigation">
    <ng-container *ngIf="isAuthenticated">
      <div class="logo-title-wrapper">
        <a [routerLink]="'/'" [replaceUrl]="true" class="home-link">
          <img
            src="assets/images/LynnCo-Logo-Full-Color.png"
            width="45"
            height="40"
            alt="Lynnco Logo"
            loading="lazy"
          />
          <strong>LynnCo BI</strong>
        </a>
      </div>
      <div *ngIf="isLoadingMenu" class="menu-loading-container">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <div *ngIf="!isLoadingMenu && menu.length === 0" class="no-reports-message">
        <mat-icon class="no-reports-icon">info_outline</mat-icon>
        <p class="no-reports-text">No reports are currently available for your user account.</p>
      </div>
      <mat-nav-list *ngIf="!isLoadingMenu && menu.length > 0">
        <ng-container *ngFor="let parent of menu | menuParents; let i = index">
          <ng-container
            *ngTemplateOutlet="
              recursiveMenu;
              context: { $implicit: parent, level: 0, parentIndex: i, parentPath: i.toString() }
            "
          ></ng-container>
        </ng-container>
        <ng-template
          #recursiveMenu
          let-item
          let-level="level"
          let-parentIndex="parentIndex"
          let-parentPath="parentPath"
          class="mat-drawer-inner-container-a"
        >
          <mat-list-item [style.padding-left.px]="level * 10" class="list-item-element">
            <a *ngIf="item.url" mat-list-item (click)="selectReport(item)" [class.selected-menu-item]="selectedMenuItemUrl === item.url" style="cursor: pointer">
              <mat-icon class="menu-item-bar-chart">bar_chart</mat-icon>
              {{ item.label }}
            </a>
            <span
              *ngIf="!item.url"
              (click)="toggleCategory(item.categoryId)"
              style="display: flex; align-items: center; cursor: pointer"
            >
              <mat-icon class="menu-item-arrow">
                {{ isCategoryExpanded(item.categoryId) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
              {{ item.label }}
            </span>
          </mat-list-item>
          <ng-container *ngIf="!item.url && isCategoryExpanded(item.categoryId)">
            <ng-container
              *ngFor="let child of menu | menuChildren: item.categoryId; let ci = index"
            >
              <ng-container
                *ngTemplateOutlet="
                  recursiveMenu;
                  context: {
                    $implicit: child,
                    level: level + 1,
                    parentIndex: ci,
                    parentPath: parentPath + '-' + ci,
                  }
                "
              ></ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </mat-nav-list>
    </ng-container>
  </mat-sidenav>

  <mat-sidenav-content [class.full-width-content]="shouldHideNavigation">
    <ng-container *ngIf="isAuthenticated && !shouldHideNavigation">
      <mat-toolbar color="primary">
        <span class="toolbar-spacer"></span>
        <ng-container *ngIf="isAuthenticated">
          <span class="user-info"> Hi {{ userName }} </span>
        </ng-container>
      </mat-toolbar>
    </ng-container>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
